<template>
  <section class="card">
    <div class="card-body">
      <header class="activity-history-table__header">
        <h4>{{ title }}</h4>
        <p>{{ subtitle }}</p>
      </header>

      <section class="app-table-wrap">
        <div class="app-table-scroll">
          <table class="app-data-table">
            <thead>
              <tr>
                <th class="app-col-index">{{ resolvedHeaders.index }}</th>
                <th>{{ resolvedHeaders.date }}</th>
                <th>{{ resolvedHeaders.module }}</th>
                <th>{{ resolvedHeaders.event }}</th>
                <th>{{ resolvedHeaders.description }}</th>
                <th>{{ resolvedHeaders.user }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" class="app-table-empty">{{ loadingText }}</td>
              </tr>

              <tr v-else-if="normalizedRows.length === 0">
                <td colspan="6" class="app-table-empty">{{ emptyText }}</td>
              </tr>

              <tr v-else v-for="(row, index) in normalizedRows" :key="row.id">
                <td class="app-muted">{{ index + 1 }}</td>
                <td>{{ row.dateLabel }}</td>
                <td>{{ row.moduleLabel }}</td>
                <td>{{ row.eventLabel }}</td>
                <td class="app-strong">{{ row.descriptionLabel }}</td>
                <td>{{ row.actorLabel }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActivityHistoryTable',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loadingText: {
      type: String,
      default: 'Cargando historial...',
    },
    emptyText: {
      type: String,
      default: 'Sin movimientos registrados en el historial.',
    },
    headers: {
      type: Object,
      default: () => ({}),
    },
    rowFallback: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    resolvedHeaders() {
      const incoming = this.headers && typeof this.headers === 'object' ? this.headers : {};

      return {
        index: String(incoming.index || '#').trim() || '#',
        date: String(incoming.date || 'Fecha').trim() || 'Fecha',
        module: String(incoming.module || 'Módulo').trim() || 'Módulo',
        event: String(incoming.event || 'Evento').trim() || 'Evento',
        description: String(incoming.description || 'Descripción').trim() || 'Descripción',
        user: String(incoming.user || 'Usuario').trim() || 'Usuario',
      };
    },
    resolvedRowFallback() {
      const incoming = this.rowFallback && typeof this.rowFallback === 'object' ? this.rowFallback : {};

      return {
        date: String(incoming.date || '-').trim() || '-',
        module: String(incoming.module || 'General').trim() || 'General',
        event: String(incoming.event || 'Cambio').trim() || 'Cambio',
        description: String(incoming.description || 'Actividad registrada').trim() || 'Actividad registrada',
        actor: String(incoming.actor || 'Sistema').trim() || 'Sistema',
      };
    },
    normalizedRows() {
      return (Array.isArray(this.rows) ? this.rows : [])
        .filter((row) => row && typeof row === 'object')
        .map((row, index) => ({
          id: row.id || `row-${index}`,
          dateLabel: String(row.date_label || row.dateLabel || this.resolvedRowFallback.date).trim() || this.resolvedRowFallback.date,
          moduleLabel: String(row.module_label || row.moduleLabel || this.resolvedRowFallback.module).trim() || this.resolvedRowFallback.module,
          eventLabel: String(row.event_label || row.eventLabel || this.resolvedRowFallback.event).trim() || this.resolvedRowFallback.event,
          descriptionLabel: String(row.description_label || row.descriptionLabel || row.title || this.resolvedRowFallback.description).trim() || this.resolvedRowFallback.description,
          actorLabel: String(row.actor_label || row.actorLabel || row.actor_name || this.resolvedRowFallback.actor).trim() || this.resolvedRowFallback.actor,
        }));
    },
  },
};
</script>
